<div class="pending-page">

  <!-- ================================================================
       ENCABEZADO
       ================================================================ -->
  <div class="page-header">

    <div class="page-header-content">

      <div class="page-header-icon">
        <i class="fa-solid fa-chart-line"></i>
      </div>

      <div class="page-header-text">
        <span class="page-eyebrow">SEGUIMIENTO</span>

        <h4 class="page-title">
          Firmas pendientes de avance
        </h4>

        <p class="page-description">
          Consulta y da seguimiento al progreso de tus procesos de firma.
        </p>
      </div>

    </div>

    <div class="page-counter" *ngIf="totalItems">
      <span class="page-counter-value">
        {{ currentItems?.length || 0 }}
      </span>

      <span class="page-counter-text">
        de {{ totalItems }}
      </span>
    </div>

  </div>


  <!-- ================================================================
       BÚSQUEDA
       ================================================================ -->
  <div class="search-section">

    <form [formGroup]="formSearch">

      <label class="search-label">
        Buscar sobre
      </label>

      <div class="search-wrapper">

        <div class="search-icon">
          <i class="fa fa-search"></i>
        </div>

        <input type="text" class="search-input" placeholder="Buscar por título..." aria-label="Búsqueda por título"
          formControlName="search" />

        <button type="submit" class="search-button" [disabled]="spinner" (click)="search()">

          <span *ngIf="!spinner">
            Buscar
          </span>

          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="spinner">
          </span>

        </button>

      </div>

    </form>

  </div>


  <!-- ================================================================
       TABLA
       ================================================================ -->
  <div class="table-section">

    <app-paginacion [currentPage]="currentPage" [totalItems]="totalItems" [selectedPageSize]="pageSize"
      [paginatedData]="currentItems" [headers]="tableHeaders" [actions]="customActions"
      (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)" [loading]="spinner">
    </app-paginacion>

  </div>

</div>


<!-- ==================================================================
     MODAL RESUMEN
     ================================================================== -->

<ng-template #modalGruposResumenes let-modal>

  <div class="summary-modal">


    <!-- ==============================================================
         HEADER
         ============================================================== -->

    <div class="summary-modal-header">

      <div class="summary-modal-heading">

        <div class="summary-modal-icon">
          <i class="fa-solid fa-chart-line"></i>
        </div>

        <div class="summary-modal-heading-text">

          <h4>
            Resumen de firma
          </h4>

          <p>
            Consulta el avance de firmas del lote.
          </p>

        </div>

      </div>


      <button type="button" class="summary-close" aria-label="Cerrar" (click)="modal.dismiss('Cross click')">

        <i class="fa-solid fa-xmark"></i>

      </button>

    </div>


    <!-- ==============================================================
         BODY
         ============================================================== -->

    <div class="summary-modal-body">


      <!-- LOTE -->

      <div class="summary-document">

        <div class="summary-document-icon">
          <i class="fa-regular fa-file-lines"></i>
        </div>

        <div class="summary-document-info">

          <span>
            Lote seleccionado
          </span>

          <strong>
            {{ loteSelected.titulo }}
          </strong>

        </div>

      </div>


      <!-- ============================================================
           RESÚMENES
           ============================================================ -->

      <div class="summary-list">

        <div class="resume-modal" *ngFor="let resumen of resumenAvanceFirma; index as i">


          <!-- HEADER DEL GRUPO -->

          <div class="resume-header">

            <div class="resume-group">

              <div class="resume-group-icon">

                <i class="fa-solid" [ngClass]="resumen.es_grupo ? 'fa-users' : 'fa-user'">
                </i>

              </div>


              <div class="resume-group-info">

                <span class="resume-group-label">
                  {{ resumen.es_grupo ? 'Grupo' : 'Firmante' }}
                </span>

                <strong class="resume-group-name">
                  {{ resumen.nombre }}
                </strong>

              </div>

            </div>


            <span class="resume-tag" *ngIf="resumen.es_grupo">

              Firma grupal

            </span>


            <span class="resume-tag resume-tag-individual" *ngIf="!resumen.es_grupo">

              Firma individual

            </span>

          </div>


          <!-- ========================================================
               ESTADÍSTICAS
               ======================================================== -->

          <div class="resume-stats">


            <div class="resume-stat">

              <div class="resume-stat-icon requested">
                <i class="fa-regular fa-file-lines"></i>
              </div>

              <div>

                <span class="resume-stat-label">
                  Solicitadas
                </span>

                <span class="resume-stat-value">
                  {{ resumen.cantidad_total }}
                </span>

              </div>

            </div>


            <div class="resume-stat">

              <div class="resume-stat-icon completed">
                <i class="fa-solid fa-check"></i>
              </div>

              <div>

                <span class="resume-stat-label">
                  Completadas
                </span>

                <span class="resume-stat-value">
                  {{ resumen.cantidad_firmada }}
                </span>

              </div>

            </div>


            <div class="resume-stat">

              <div class="resume-stat-icon pending">
                <i class="fa-regular fa-clock"></i>
              </div>

              <div>

                <span class="resume-stat-label">
                  Pendientes
                </span>

                <span class="resume-stat-value">

                  {{
                  resumen.cantidad_total -
                  resumen.cantidad_firmada
                  }}

                </span>

              </div>

            </div>

          </div>


          <!-- ========================================================
               PROGRESO
               ======================================================== -->

          <div class="resume-progress">

            <div class="resume-progress-header">

              <span>
                Progreso general
              </span>

              <strong>
                {{ getProgress(resumen) }}%
              </strong>

            </div>


            <div class="resume-progress-track">

              <div class="resume-progress-bar" [style.width.%]="getProgress(resumen)">
              </div>

            </div>


            <div class="resume-progress-footer">

              <span>
                {{ resumen.cantidad_firmada }}
                de
                {{ resumen.cantidad_total }}
                firmas completadas
              </span>

            </div>

          </div>

        </div>

      </div>

    </div>


    <!-- ==============================================================
         FOOTER
         ============================================================== -->

    <div class="summary-modal-footer">

      <button type="button" class="btn-modal-secondary" (click)="modal.close('Cerrar click')">

        Cerrar

      </button>


      <button type="button" class="btn-modal-primary" (click)="rederic('firmas/firmantes/' + loteSelected.id)"
        *ngIf="loteSelected.es_grupo">

        <i class="fa fa-eye"></i>

        <span>
          Ver detalle
        </span>

      </button>

    </div>

  </div>

</ng-template>